import { FormGroup, ValidationErrors } from '@angular/forms';

export function s10CodeValidator(group: FormGroup): ValidationErrors | null {
  const s10CodeControl = group.get('s10code');

  if (s10CodeControl) {
    const s10CodeValue = s10CodeControl.value;

    if (
      s10CodeValue &&
      s10CodeControl.errors &&
      s10CodeControl.errors.pattern
    ) {
      s10CodeControl.setErrors([
        'BATCH_MAILING.BATCHES_TAB.CREATE_TABLE.VALIDATION_S10_CODE',
      ]);

      return { error: true };
    }
  }

  return null;
}
